module.exports = __webpack_public_path__ + "static/img/anli3.084b005.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anli3.jpg
// module id = QjxD
// module chunks = 1